import { Injectable } from '@angular/core';
import { ApiClientService } from './util/api.client.service';

declare const $: any;

@Injectable()
export class OperatorService {
    constructor(private http: ApiClientService) { }

    getOperator(id: number) {
        return this.http.get('/secure/operator/' + id, { secure: false });
    }
    getOperatorRoles(id: number) {
        return this.http.get('/roles/operator/' + id);
    }
    getAllOperators(search: any, page: any, size: any) {
        return this.http.get('/operator/list?&search=' + search + '&page=' + page + '&size=' + size);
    }
    getOperatorByMinProfile(profileId: number) {
        return this.http.get('/secure/admin/person/profile/' + profileId, { secure: false });
    }
    getOperatorByProfile(profileId: number) {
        return this.http.get('/person/profile/' + profileId, { secure: true });
    }
    getOperatorOfMinistery(profileId: number) {
        return this.http.get('/secure/admin/person/profile/' + profileId, { secure: false });
    }
    postOperator(operator: any) {
        return this.http.post('/operator', operator);
    }
    putOperator(operator: any) {
        return this.http.put('/operator/' + operator.id, operator);
    }
    deleteOperator(operatorId: number) {
        return this.http.delete('/operator/' + operatorId);
    }
    getProfiles() {
        return this.http.get('/profiles');
    }
    getMinProfiles() {
        return this.http.get('/secure/admin/profiles/active', { secure: false });
    }
    getRoles() {
        return this.http.get('/secure/roles', { secure: false });
    }
    getFilterOperators(search: string) {
        return this.http.get('/operator/filter/' + search);
    }
    getAll() {
        return this.http.get('/operator/list');
    }
    get(id: number) {
        return this.http.get('/operator/' + id);
    }
    changeOperatorPassword(operator: any) {
        return this.http.put('/secure/educationalCenter/1/level/1/operator/changePassword/' + operator.id, operator, { secure: false });
    }
    resetOperatorPassword(operator: any) {
        return this.http.put('/secure/educationalCenter/1/level/1/operator/resetPassword/' + operator.id, operator, { secure: false });
    }
    getRolesByOperatorId(operatorId: any) {
        return this.http.get('/rol/operator/' + operatorId);
    }
    lastDateLogin(operator: any) {
        return this.http.put('/lastDateLogin/operator/' + operator.id, operator);
    }
    containRole(operatorRoles: any[], args: any) {
        const systemOwner = JSON.parse(localStorage.getItem('currentUser')) ? JSON.parse(localStorage.getItem('currentUser')).authToken.claims.scopes.systemOwner : false;
        if (systemOwner) {
            return true;
        } else {
            let res = false;
            if (operatorRoles.length > 0) {
                operatorRoles.forEach((oRole: any) => {                    
                    if (oRole.name === args) {
                        res = true;
                        }
                });
                return res;
            } else {
                return false;
            }
        }
    }
    getEducationalCenters(operatorId: any) {
        return this.http.get('/operator/' + operatorId + '/educationalCenter');
    }
    downloadPDFoperator(operatorId: any, profileId: any, schoolShifts: any) {
        return this.http.put('/files/download/pdf/operator/' + operatorId + '/profile/' + profileId, schoolShifts);
    }
    getAllStatus(): any {
        return this.http.get('/secure/status', { secure: false });
    }
    advancedSearch(model: any) {
        const status = model.statusCode !== null ? 'status=' + model.statusCode : '';
        const profile = model.profileId !== null ? '&profileId=' + model.profileId : '';
        const dateF = model.dateFrom !== null ? '&dateFrom=' + model.dateFrom : '';
        const dateT = model.dateTo !== null ? '&dateTo=' + model.dateTo : '';

        return this.http.get('/operator/advancedSearch?' + status + profile + dateF + dateT);
    }

    checkDU(value: any) {
        if (value) {
            const regex = new RegExp(/^[A-Za-z0-9\-]+$/g);
            const test = regex.test(value);
            if (!test) {
                this.dialog('El DU solo puede tener números, letras y guion');
                return false;
            } else {
                return true;
            }
        } else {
            this.dialog('Rellene el campo DU');
            return false;
        }
    }
    
    getServerDate(): any {
        return this.http.get('/date', { secure: false });
    }

    dialog(msg: string) {
        $.notify({
            icon: 'notifications',
            message: msg
        }, {
                type: 'rose',
                timer: 3000,
                placement: {
                    from: 'top',
                    align: 'center'
                }
            });
    }


    //Staff
    checkEmail(emailModel: any) {
        return this.http.put('/secure/admin/operator/repeat/email', emailModel, { secure: false });
    }

    sendMail(documentNumber:string, sex: string){
        return this.http.get('/password/reset/docNumber/' + documentNumber + '/sex/' + sex , { secure: false });
    }

    resetPassword(resetPassword: any) {
        return this.http.post('/password/reset', resetPassword, { secure: false });
    }

    getOpertorsByEducationalCenter(param: any){
        return this.http.get('/operator/advancedSearch/list' + param, { secure: true });
    }

    isDirector(){
        return this.http.get('/profiles/director', { secure: true });
    }
}



// WEBPACK FOOTER //
// D:/Projects/GitHub/education-ee-web/src/app/services/operator.service.ts